"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Prevent the backspace key from navigating back.
// http://stackoverflow.com/a/2768256/390330
exports.preventBackspaceNav = function () {
    document.addEventListener('keydown', function (event) {
        var doPrevent = false;
        if (event.keyCode === 8) {
            var d = event.srcElement || event.target;
            if ((d.tagName.toUpperCase() === 'INPUT' &&
                (d.type.toUpperCase() === 'TEXT' ||
                    d.type.toUpperCase() === 'PASSWORD' ||
                    d.type.toUpperCase() === 'FILE' ||
                    d.type.toUpperCase() === 'SEARCH' ||
                    d.type.toUpperCase() === 'EMAIL' ||
                    d.type.toUpperCase() === 'NUMBER' ||
                    d.type.toUpperCase() === 'DATE')) ||
                d.tagName.toUpperCase() === 'TEXTAREA') {
                doPrevent = d.readOnly || d.disabled;
            }
            else {
                doPrevent = true;
            }
        }
        if (doPrevent) {
            event.preventDefault();
        }
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/utils/preventBackspaceNav.js
 ** module id = 468
 ** module chunks = 0
 **/